import _ from 'underscore';
import { statusesHash } from '@culture/utils/helpers/statuses';

import { filterQuery } from '@culture/common-helpers/url';
import { endOfDay, parseISO, startOfDay } from 'date-fns';
import * as actions from './actions';

export const getEventsCatalog = ({ ...params }) => async (dispatch) => {
	const { seanceStartDate, seanceEndDate } = params;

	const eventsParams = filterQuery({
		..._(params).pick('limit', 'query', 'cleanCache', 'page'),
		seanceStartDate: seanceStartDate && startOfDay(parseISO(seanceStartDate)),
		seanceEndDate: seanceEndDate && endOfDay(parseISO(seanceEndDate)),
		fields: [
			'_id',
			'title',
			'endDate',
			'name',
			'nearestDate',
			'nearestSeances',
			'thumbnailFile',
			'seanceEndDate',
			'seanceStartDate',
			'seances',
			'organization',
			'type',
			'ageRestriction',
			'places'
		].join(),
		locationName: params?.locale,
		isMuseumExhibition: true,
		isOnlyActual: true,
		statuses: [statusesHash.published],
		sort: params?.season ? `${params?.season}Sort,startDate` : 'startDate',
		cached: true
	});

	await dispatch(actions.getEvents(eventsParams));
};

export default {
	getEventsCatalog
};
